<div class="root-container">
    <div class="mfa-container">
        <div class="mfa-header">
            <div class="logo">
                <i class="icon-smash_icologo_chip"></i>
            </div>
            <ng-container *ngIf="selectedFactor === 'email'">
                <h1 translate>{{ 'MFA_CHALLENGE_EMAIL_TITLE' | translate }}</h1>
            </ng-container>
            <ng-container *ngIf="selectedFactor === 'application'">
                <h1 translate>{{ 'MFA_CHALLENGE_APPLICATION_TITLE' | translate }}</h1>
            </ng-container>
        </div>
        <ng-container *ngIf="!selectedFactor">
            <div class="mfa-description" translate>
                <div class="mfa-spinner-container">
                    <div class="loading-spinner-grey"></div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="selectedFactor">
            <ng-container *ngIf="selectedFactor === 'email'; then emailFactor; else applicationFactor"></ng-container>
            <div class="mfa-help">
                <ul>
                    <li *ngFor="let factor of otherFactors">
                        <a (click)="selectFactor(factor)" translate>{{ factorTranslations[factor] }}</a>
                    </li>
                    <a href="{{'MFA_CHALLENGE_HELP_URL' | translate}}" target="_blank">{{ 'MFA_CHALLENGE_HELP' | translate }}</a>
                </ul>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #emailFactor>
    <div class="mfa-email">
        <ng-container *ngIf="(mfaSendOtpLoading$ | async)">
            <div class="mfa-spinner-container">
                <div class="loading-spinner-white"></div>
            </div>
        </ng-container>
        <ng-container *ngIf="!(mfaSendOtpLoading$ | async)">
            <p [innerHtml]="'MFA_CHALLENGE_EMAIL_DESCRIPTION' | translate: {username: decodedToken?.username} | translate | safeHtml"></p>
            <div class="send-new-otp-label">
                <span class="send-new-otp-label-question" translate>PREMIUM_PROFILE_2FA_FACTORS_EMAIL_MODAL_CONFIGURATION_NEW_OTP_NEED_HELP</span>
                <span class="send-new-otp-cta-label" translate (click)="sendEmailOtp()">
                    PREMIUM_PROFILE_2FA_FACTORS_EMAIL_MODAL_CONFIGURATION_SEND_NEW_OTP_LABEL
                </span>
            </div>
            <div class="otp-validation-input-container">
                <app-smash-verification-code #verificationCode (valueChange)="verifyOtp('email', $event)"
                    [isVerificationFailed]="!!(verifyOtpError$ | async)" [isVerificationLoaded]="verifyOtpLoaded$ | async">
                </app-smash-verification-code>
            </div>
            <div *ngIf="!!(verifyOtpError$ | async)" class="error-message">{{ 'MFA_CHALLENGE_INVALID_OTP' | translate }}</div>
            <div class="mfa-form-footer">
                <app-smash-button width='14rem' height="4rem" [text]="'SIGNIN_BUTTON_LABEL_CANCEL' | translate" [color]="'white'"
                    [disabled]="(verifyOtpLoading$ | async) || (verifyOtpLoaded$ | async) || (mfaSendOtpLoading$ | async)" [loading]="false"
                    (onClick)="back()">
                </app-smash-button>
                <app-smash-button width='14rem' height="4rem" [text]="'MFA_CHALLENGE_VALIDATE' | translate"
                    [loading]="(verifyOtpLoading$ | async) || (verifyOtpLoaded$ | async) || (mfaSendOtpLoading$ | async)"
                    [disabled]="(verifyOtpLoading$ | async) || (verifyOtpLoaded$ | async) || (mfaSendOtpLoading$ | async)" (onClick)="verifyOtp()">
                </app-smash-button>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #applicationFactor>
    <ng-container *ngIf="isSelectedFactorVerified() | async">
        <div class="mfa-application">
            <p [innerHtml]="'MFA_CHALLENGE_APPLICATION_VERIFIED_DESCRIPTION' | translate | safeHtml"></p>
            <div class="otp-validation-input-container">
                <app-smash-verification-code #verificationCode (valueChange)="verifyOtp('application', $event)"
                    [isVerificationFailed]="!!(verifyOtpError$ | async)" [isVerificationLoaded]="verifyOtpLoaded$ | async">
                </app-smash-verification-code>
            </div>
            <div *ngIf="!!(verifyOtpError$ | async)" class="error-message">{{ 'MFA_CHALLENGE_INVALID_OTP' | translate }}</div>
            <div class="mfa-form-footer">
                <app-smash-button width='14rem' height="4rem" [text]="'SIGNIN_BUTTON_LABEL_CANCEL' | translate" [color]="'white'"
                    [disabled]="(verifyOtpLoading$ | async) || (verifyOtpLoaded$ | async) || (mfaSendOtpLoading$ | async)" [loading]="false"
                    (onClick)="back()">
                </app-smash-button>
                <app-smash-button width='14rem' height="4rem" [text]="'MFA_CHALLENGE_VALIDATE' | translate"
                    [loading]="(verifyOtpLoading$ | async) || (verifyOtpLoaded$ | async) || (mfaSendOtpLoading$ | async)"
                    [disabled]="(verifyOtpLoading$ | async) || (verifyOtpLoaded$ | async) || (mfaSendOtpLoading$ | async)" (onClick)="verifyOtp()">
                </app-smash-button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!(isSelectedFactorVerified()  | async)">
        <div class="mfa-application">
            <ng-container *ngIf="!(mfaApplicationSecret$ | async)">
                <ng-container *ngIf="createMfaApplicationFactorSecretLoading$ | async">
                    <div class="loading-spinner-container">
                        <div class="loading-spinner-grey"></div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="(mfaApplicationSecret$ | async)">
                <ng-container *ngIf="applicationConfigurationStep === 'qrCode'">
                    <p [innerHtml]="'MFA_CHALLENGE_APPLICATION_NOT_VERIFIED_DESCRIPTION' | translate | safeHtml"></p>
                    <app-smash-mfa-authenticator-setup [secret]="mfaApplicationSecret$ | async"
                        [username]="decodedToken?.username"></app-smash-mfa-authenticator-setup>
                    <div class="mfa-form-footer">
                        <app-smash-button width='14rem' height="4rem" [text]="'SIGNIN_BUTTON_LABEL_CANCEL' | translate" [loading]="false" [disabled]="false" [color]="'white'"
                            (onClick)="back()">
                        </app-smash-button>
                        <app-smash-button width='14rem' height="4rem" [text]="'MFA_CHALLENGE_APPLICATION_BUTTON_NEXT_LABEL' | translate" [loading]="false" [disabled]="false"
                            [color]="'red'" (onClick)="setApplicationConfigurationStep('otpVerification')">
                        </app-smash-button>
                    </div>
                </ng-container>
                <ng-container *ngIf="applicationConfigurationStep === 'otpVerification'">
                    <div class="description" [innerHtml]="'MFA_CHALLENGE_APPLICATION_VERIFICATION_DESCRIPTION' | translate | safeHtml"></div>
                    <div class="otp-validation-input-container">
                        <app-smash-verification-code #verificationCode (valueChange)="verifyApplicationFactor($event)"
                            [isVerificationFailed]="verifyApplicationFactorError$ | async"
                            [isVerificationLoaded]="verifyApplicationFactorLoading$ | async">
                        </app-smash-verification-code>
                    </div>
                    <div class="error-message" *ngIf="verifyApplicationFactorError$ | async" translate>
                        MFA_CHALLENGE_APPLICATION_TOTP_VERIFY_ERROR_MESSAGE
                    </div>
                    <div class="mfa-form-footer">
                        <app-smash-button width='14rem' height="4rem" [text]="'SIGNIN_BUTTON_LABEL_CANCEL' | translate" [loading]="verifyApplicationFactorLoading$ | async"
                            [disabled]="verifyApplicationFactorLoading$ | async" [color]="'white'"
                            (onClick)="setApplicationConfigurationStep('qrCode')">
                        </app-smash-button>
                        <app-smash-button width='14rem' height="4rem" [text]="'MFA_CHALLENGE_APPLICATION_TOTP_VERIFY_BUTTON_LABEL' | translate"
                            [loading]="verifyApplicationFactorLoading$ | async" [disabled]="verifyApplicationFactorLoading$ | async" [color]="'red'"
                            (onClick)="verifyApplicationFactor()">
                        </app-smash-button>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
</ng-template>